/**
 * @generated SignedSource<<8f8a2cdbc835d057d5fa66408992c882>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
export type OrganizationContextInput = {
  clientMutationId?: string | null;
  cloudId?: string | null;
  orgId?: string | null;
};
export type BootstrapQuery$variables = {
  context?: OrganizationContextInput | null;
};
export type BootstrapQuery$data = {
  readonly bootstrap: {
    readonly cloudIds: ReadonlyArray<string> | null;
    readonly collabContext: {
      readonly cloudIds: ReadonlyArray<string>;
      readonly collabContextSiteAris: ReadonlyArray<string> | null;
      readonly hasMultipleUnits: boolean;
      readonly isMultiSite: boolean;
    } | null;
    readonly orgId: string;
    readonly userIsOrgAdmin: boolean;
    readonly workspaces: ReadonlyArray<{
      readonly cloudId: string;
      readonly id: string;
      readonly type: WorkspaceType;
      readonly uuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"CapabilityRouterFragment" | "storeHomeWorkspace" | "utils_checkUserHasCapabilities">;
    } | null> | null;
  } | null;
};
export type BootstrapQuery = {
  response: BootstrapQuery$data;
  variables: BootstrapQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "organizationContext",
    "variableName": "context"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v3 = {
  "kind": "ScalarField",
  "name": "cloudIds"
},
v4 = {
  "concreteType": "CollabContextBootstrap",
  "kind": "LinkedField",
  "name": "collabContext",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isMultiSite"
    },
    {
      "kind": "ScalarField",
      "name": "collabContextSiteAris"
    },
    {
      "kind": "ScalarField",
      "name": "hasMultipleUnits"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "userIsOrgAdmin"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v8 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "keyPrefix"
},
v12 = {
  "kind": "ScalarField",
  "name": "timezone"
},
v13 = {
  "kind": "ScalarField",
  "name": "goalScoringMode"
},
v14 = {
  "kind": "ScalarField",
  "name": "activationId"
},
v15 = {
  "kind": "ScalarField",
  "name": "capability"
},
v16 = {
  "kind": "ScalarField",
  "name": "capabilityContainer"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BootstrapQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AtlassianHomeBootstrap",
        "kind": "LinkedField",
        "name": "bootstrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "WorkspaceSummary",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "storeHomeWorkspace",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v8/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v14/*: any*/)
                ],
                "argumentDefinitions": []
              },
              {
                "kind": "FragmentSpread",
                "name": "CapabilityRouterFragment"
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "utils_checkUserHasCapabilities",
                "selections": [
                  {
                    "concreteType": "UserCapabilities",
                    "kind": "LinkedField",
                    "name": "userCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Capability",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "argumentDefinitions": []
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BootstrapQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AtlassianHomeBootstrap",
        "kind": "LinkedField",
        "name": "bootstrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "WorkspaceSummary",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "concreteType": "UserCapabilities",
                "kind": "LinkedField",
                "name": "userCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Capability",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "bd73d62310e36c080c5494d83494a02f",
    "id": null,
    "metadata": {},
    "name": "BootstrapQuery",
    "operationKind": "query",
    "text": "query BootstrapQuery(\n  $context: OrganizationContextInput\n) {\n  bootstrap(organizationContext: $context) {\n    orgId\n    cloudIds\n    collabContext {\n      cloudIds\n      isMultiSite\n      collabContextSiteAris\n      hasMultipleUnits\n    }\n    userIsOrgAdmin\n    workspaces {\n      id\n      uuid\n      cloudId\n      type\n      ...storeHomeWorkspace\n      ...CapabilityRouterFragment\n      ...utils_checkUserHasCapabilities\n    }\n  }\n}\n\nfragment CapabilityRouterFragment on WorkspaceSummary {\n  userCapabilities {\n    capabilities {\n      capability\n      capabilityContainer\n      id\n    }\n  }\n}\n\nfragment storeHomeWorkspace on WorkspaceSummary {\n  id\n  uuid\n  name\n  keyPrefix\n  timezone\n  cloudId\n  goalScoringMode\n  type\n  activationId\n}\n\nfragment utils_checkUserHasCapabilities on WorkspaceSummary {\n  userCapabilities {\n    capabilities {\n      capability\n      capabilityContainer\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d250ccd30a992afc9249f01724bebb4";

export default node;
